import { Modal } from 'antd';
import styled from 'styled-components';
import { SupportIcon } from './Icons';
import HelpComponent from './HelpComponent';

const SupportModal = ({ open, onClose }) => {
    return (
    <Modal
            open={open}
            onCancel={onClose}
            title={
                <Header>
                    <IconLarge>
                        <SupportIcon />
                    </IconLarge>
                    <HeaderTitle>Помощь</HeaderTitle>
                </Header>
            }
            footer={null}
            width={'80vw'}
            style={{ top: '10vh' }}
            styles={{ body: { height: '70vh', overflowY: 'auto' } }}
            closable={true}
        >
            <HelpComponent />
        </Modal>
    );
};

export default SupportModal;

// Body styles moved to SupportModalBody.jsx

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
`;

const IconLarge = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    & > svg { width: 48px; height: 48px; }
`;

const HeaderTitle = styled.h2`
    margin: 0;
    font-size: 20px;
`;
// PhoneLink moved to SupportModalBody.jsx